import { useAutoScroll } from 'components/hooks';
import { useOrientation } from 'components/hooks';
import React, {useState, useEffect} from "react";
import MatchAudioPng from "utils/assets/images/Match-Audio.png";
import { DndProvider, useDragLayer } from 'react-dnd';

export const CustomDragPreview = () => {
    const { startAutoScroll, stopAutoScroll, updateTouchPosition } = useAutoScroll();
    const isLandscape = useOrientation();

    const {
        isDragging,
        item,
        initialOffset,
        currentOffset,
    } = useDragLayer((monitor) => ({
        item: monitor.getItem(),
        initialOffset: monitor.getInitialSourceClientOffset(),
        currentOffset: monitor.getSourceClientOffset(),
        isDragging: monitor.isDragging(),
    }));

    useEffect(() => {
        if (isDragging && currentOffset) {
            const mockEvent = {
                touches: [{ 
                    clientX: currentOffset.x, 
                    clientY: currentOffset.y 
                }]
            };
            updateTouchPosition(mockEvent);
            startAutoScroll();
        } else {
            stopAutoScroll();
        }

        return stopAutoScroll;
    }, [isDragging, currentOffset, startAutoScroll, stopAutoScroll, updateTouchPosition]);

    if (!isDragging || !item) {
        return null;
    }

    const layerStyles = {
        position: 'fixed',
        pointerEvents: 'none',
        zIndex: 100000,
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
    };

    const getItemStyles = (initialOffset, currentOffset, dragOffset = { x: 0, y: 0 }) => {
        if (!initialOffset || !currentOffset) {
            return {
                display: 'none',
            };
        }

        const { x, y } = currentOffset;

        const transform = `translate(${x + dragOffset.x}px, ${y + dragOffset.y}px)`;
        return {
            transform,
            WebkitTransform: transform,
            opacity: 0.9,
            position: 'absolute',
            transformOrigin: 'top right',
            margin: 0,
            padding: 0,
            border: 'none',
            outline: 'none'
        };
    };

    const renderPreview = () => {
        const MatchType = item.MatchType || 'Text';
        // console.log(MatchType, "MatchType", item);
        
        const baseContainerStyle = {
            display: "flex",
            marginTop: "20px",
            flexWrap: "wrap",
            opacity: 0.9,
            cursor: "grab",
            marginRight: "20px",
            touchAction: "none",
            userSelect: "none",
            WebkitUserSelect: "none",
            border: "1px solid gray",
            borderRadius: "5px",
            padding: "5px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            background: "white"
        };

        const indexStyle = {
            borderRadius: "0px !important",
            minWidth: "20px",
            marginRight: "5px",
            maxHeight: "20px",
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#324b8c",

        };

        switch (MatchType) {
            case 'Text':
                return (
                    <div style={baseContainerStyle}>
                        <div>
                            <div style={indexStyle} className="matchItemIndex">
                                {String.fromCharCode(65 + item.id)}
                            </div>
                        </div>
                        <div style={{ color: "black", marginLeft: "5px" }}>
                            {item.text}
                        </div>
                    </div>
                );
            
            case 'Image':
            case 'Audio':
            case 'ImageAndAudio':
                return (
                    <div style={baseContainerStyle}>
                        <div>
                            <div style={indexStyle} className="matchItemIndex">
                                {String.fromCharCode(65 + item.id)}
                            </div>
                            {MatchType === "ImageAndAudio" && (
                                <div style={{ marginTop: "20px" }}>
                                    <img
                                        src={MatchAudioPng}
                                        alt="audio"
                                        loading="lazy"
                                        style={{
                                            width: "23px",
                                            height: "23px",
                                            objectFit: "cover",
                                            borderRadius: "50%",
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                        <img
                            src={MatchType === 'Audio' ? MatchAudioPng : item.image}
                            alt="Drag Preview"
                            loading="lazy"
                            style={{
                                maxWidth: "100px",
                                maxHeight: "100px",
                                objectFit: "contain",
                            }}
                        />
                    </div>
                );
            
            default:
                return null;
        }
    };

    return (
        <div style={layerStyles}>
            <div style={getItemStyles(initialOffset, currentOffset, { x: isLandscape ? 0 : 0, y: isLandscape ? 0 : 0 }, {backgroundColor: 'blue'})}>
                {renderPreview()}
            </div>
        </div>
    );
};
